import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Dropdown } from 'primeng/dropdown';
import { Subject, catchError, debounceTime, distinctUntilChanged, filter, map, takeUntil } from 'rxjs';
import { PATHS } from 'src-adisco/app-routing.module';
import { Filter } from 'src-adisco/interfaces/categories';
import { CommonService } from 'src-adisco/services/common.service';
import { FilterService } from 'src-adisco/services/filter.service';
import { HomepageService } from 'src-adisco/services/homepage.service';
import { buildCategoryHierarchyRandom, findCategoryByTree } from 'src-adisco/utils/categories';
import { DynamicReferencedFilterParam } from 'src-ironside/repositories/supplier.repository';
import { ERole, UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { ProductService } from 'src/app/shared/services/product.service';
@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['accueil.component.css'],
})
export class AccueilComponent implements OnInit, OnDestroy {
  @ViewChild('searchProduct') searchProduct: any;
  private searchProduct$ = new Subject<string>();
  roleUser = localStorage.getItem('role');
  formFilterProduct: FormGroup;
  nameUser: any;
  hasNews?: boolean;
  cli: string = 'non';
  contact: string = 'non';
  biocide: string = 'non';
  responsiveOptions!: any[];
  isAdvancedActive: boolean = false;
  visible: boolean = false;
  loadingSuplier: boolean = false;
  listCategories: any[] = [];
  listSuppliers: any[] = [];
  listCountries: any[] = [];
  listSustainableDevelopment: any[] = [
    { id: 1, label: 'Austrian Ecolabel', name: 'austrianEcolabel' },
    { id: 2, label: 'Cradle to Cradle (C2C)', name: 'cradleToCradle' },
    { id: 3, label: 'Ecocert', name: 'ecocert' },
    { id: 4, label: 'EMAS', name: 'emas' },
    { id: 5, label: 'European Ecolabel', name: 'europeanEcolabel' },
    { id: 6, label: 'FSC', name: 'fsc' },
    { id: 7, label: 'Nordic Swan', name: 'nordicSwan' },
    { id: 8, label: 'REACH', name: 'reach' }
  ];
  listAutresInformations: any[] = [
    { id: 1, label: 'Sans CLP', name: 'clpSafetyPicto', conditionValue: 'SANS' },
    { id: 2, label: 'Contact alimentaire', name: 'foodContact', conditionValue: true },
    { id: 3, label: 'Non biocide', name: 'biocide', conditionValue: false },
  ];

  listNews: any[] = [];
  newsDetail: any;
  pageNumber = 1;
  pageSize = 12;
  loadingStatus = false;
  autocompleteSearchlistProducts: any[] = [];
  isLoadingNewsDetail = false;
  selectedSupplier: any[] = [];

  biocide1Control = new FormControl(false);
  biocide2Control = new FormControl(false);
  foodContact1Control = new FormControl(false);
  foodContact2Control = new FormControl(false);
  clpSafetyPicto1Control = new FormControl(false);
  clpSafetyPicto2Control = new FormControl(false);

  userId = localStorage.getItem('userid');
  codeUser = null;
  isSupplierState = false;
  emailContact = 'sguillot@adisco.fr';
  listMemberCatalogSegmentation: any[] = [];
  private destroy$: Subject<void> = new Subject<void>();
  private unsub$: Subject<void> = new Subject<void>();

  constructor(
    private _homepageService: HomepageService,
    private _fb: FormBuilder,
    private dynamicDocumentService: DynamicDocumentService,
    private productService: ProductService,
    private _commonService: CommonService,
    private router: Router,
    public userService: UserService,
    private filterService: FilterService,

  ) {

    if (this.userId) {
      this._commonService.getUser(this.userId).pipe(
        filter(res => !!res.email),
        map((res) => {
          const currentUser = res;
          const linkToLegalEntityId = currentUser?.linkToLegalEntity?.documentId ?? '';

          return linkToLegalEntityId as string;
        })
      ).subscribe((linkToLegalEntityId) => {
        this._commonService.getInfoMember(linkToLegalEntityId).subscribe({
          next: (res) => {
            this.listMemberCatalogSegmentation = res?.memberCatalogSegmentation?.map((seg: any) => seg?.value) ?? [];
            this.codeUser = res.code;
            this.getInitApi();
            this.setSearchPipe();
          },
          error: (error) => { },
        });
      });
    }

    this._commonService.getStoreFilteredCategories().pipe(takeUntil(this.destroy$)).subscribe((allCate) => {
      if (allCate.length) {
        this.listCategories = allCate.map((category: any) => ({
          nameCategory: category.nameCategory.fr_FR,
          value: category.codeCategory
        }));
      }
    })
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    if (!this.userService.checklogin()) {
      this.router.navigate([PATHS.logout]);
    }
    this.setName();
    this.setResponsive();
    this.initForm();
    // this.formFilterProduct.reset();
  }
  initForm(): void {
    this.formFilterProduct = this._fb.group({
      categoryProduct: [],
      fournisseur: [],
      referenceProduct: [],
      clpSafetyPicto: [null],
      foodContact: [null],
      biocide: [null],
      developpementDurable: [],
      autresInformations: [],
      countryOfManufacture: [],
      brand: [],
    });
  }
  getInitApi(): void {
    !this.listCategories.length && this.fetchCategoryByHeader();
    this.getListNews();
    this.getListSuppliers();
    this.getListCountry();
    //this.getListBrands();
  }
  setResponsive(): void {
    this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
  getListNews(): void {
    let filters: any = [
      {
        fieldName: 'status',
        conditions: [
          {
            type: 'EQUALS',
            value: 'Publié',
          },
        ],
      },
      {
        fieldName: 'lang',
        conditions: [
          {
            type: 'EQUALS',
            value: 'fr',
          },
        ],
      },
      {
        fieldName: 'typeOfNews',
        conditions: [
          {
            type: 'EQUALS',
            value: 'ACTUALITES',
          },
        ],
      },
    ];
    if (this.roleUser === ERole.Supplier && this.codeUser) {
      this.isSupplierState = true;

      filters.push({
        fieldName: 'linkToLegalEntity',
        conditions: [
          {
            type: 'EQUALS',
            value: this.codeUser,
          },
        ],
      })
    }
    if (this.selectedSupplier.length > 0) {
      filters.push({
        fieldName: 'linkToLegalEntity',
        conditions: [
          {
            type: 'IN',
            value: this.selectedSupplier,
          },
        ],
      });
    }
    this.dynamicDocumentService
      .find(
        {
          collectionName: 'dynamic_news',
          filters: filters,
          sorts: {
            publishedOrder: 'DESC',
          },
          page: 1,
          pageSize: 150,
        },
        true
      )
      .subscribe({
        next: (res) => {
          this.listNews = res.content;

          //this.getListNewsSupplier(); // removed uneccesary call
        },
        error: (error) => { },
      });
  }
  onSuppliersChange(event: { value: any; }) {
    this.selectedSupplier = event.value;
    this.getListNews();
  }
  getListNewsSupplier() {
    this.listNews = this.listNews.map((element: any) => {
      this.dynamicDocumentService.find({
        collectionName: 'dynamic_legal_entity',
        filters: [
          {
            "fieldName": "code",
            "conditions": [
              {
                "type": "EQUALS",
                "value": element?.linkToLegalEntity?.[0]?.value
              }
            ]
          }
        ],
        page: 1,
        pageSize: 150
      }).subscribe((res: any) => {
        element.supplierName = res.content[0].companyName;
      });
      return element;
    });
  }
  getListCountry(): void {
    this._homepageService.getCountry().subscribe({
      next: (res) => {
        this.listCountries = res.map((item: any) => ({
          ...item,
          label: item.mapLocalLibelle.fr_FR
        }));
      },
      error: (_error) => { },
    });
  }

  getListSuppliers(): void {
    this.loadingSuplier = true;
    let filters = [
      {
        fieldName: 'typeOfLegalEntity',
        conditions: [
          {
            type: 'EQUALS',
            value: 'FOURNISSEUR',
          },
        ],
      },
      {
        fieldName: 'status',
        conditions: [
          {
            type: 'EQUALS',
            value: 'Publié',
          },
        ],
      },
    ];

    if (this.listMemberCatalogSegmentation.length) {
      filters.push({
        fieldName: "code",
        conditions: [
          {
            type: "IN",
            value: this.listMemberCatalogSegmentation as any
          }
        ]
      })
    };

    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: filters,
        sorts: {
          "companyName": "ASC"
        },
        page: 1,
        pageSize: 150,
      })
      .subscribe((res: any) => {
        this.listSuppliers = res.content;
        this.loadingSuplier = false;
      });
  };

  fetchCategoryByHeader() {
    this._commonService.getAllCategories().subscribe(res => {
      this.listCategories = res?.map((category: any) => ({
        nameCategory: category.nameCategory.fr_FR,
        value: category.codeCategory,
      }));
    })
  }

  setName() {
    let prenom = localStorage.getItem('name') || sessionStorage.getItem('name') || '';
    let nom = localStorage.getItem('surname') || sessionStorage.getItem('surname') || '';
    this.nameUser = `${prenom} ${nom}`;

  }

  setNews(event: any) {
    this.hasNews = event;
  }

  toggleAdvanced() {
    this.isAdvancedActive = !this.isAdvancedActive;
  }

  showDialog(item: any) {
    this.newsDetail = item;
    this.visible = true;

    const documentId = this.newsDetail?.linkToResources?.[0]?.documentId;
    if (documentId) {
      this.isLoadingNewsDetail = true;
      this.dynamicDocumentService
        .findById('dynamic_ressource', this.newsDetail?.linkToResources?.[0]?.documentId).pipe(
          catchError((err) => {
            this.isLoadingNewsDetail = false;
            throw err;
          })
        )
        .subscribe((res: any) => {
          this.newsDetail.file = res;
          this.isLoadingNewsDetail = false;
        });
    }

  }

  submitSearch(): void {
    this.filterService.clearFilters();
    const submitForm = {
      ...this.formFilterProduct.value,
      categoryProduct: this.formFilterProduct.value['categoryProduct']?.value,
      categoryProductLabel: this.formFilterProduct.value['categoryProduct']?.nameCategory,
    };
    this._commonService.setFilterByKey('categories', null);
    this._commonService.sendClickEventSearch(submitForm);

    this.router.navigate(['/catalogues/rechercher']);
  }

  emptyList() {
    setTimeout(() => {
      this.autocompleteSearchlistProducts = [];
    }, 300);
  }

  onSearchInput(): void {
    this.searchProduct$.next(this.formFilterProduct.value.referenceProduct);
  }

  autocomplete(term: string) {
    if (term.length >= 3) {

      let filters = [
        {
          fieldName: 'uniqueId',
          operator: "OR",
          conditions: [{ type: 'EQUALS', value: term }],
        },
        {
          fieldName: 'supplierItemNumber',
          operator: "OR",
          conditions: [{ type: 'CONTAINS', value: term }],
        },
        {
          fieldName: 'brand',
          operator: "OR",
          conditions: [{ type: 'CONTAINS', value: term }],
        },
        {
          fieldName: 'longDescription',
          operator: "OR",
          conditions: [{ type: 'CONTAINS', value: term }],
        },
        {
          fieldName: 'shortDescription',
          operator: "OR",
          conditions: [{ type: 'CONTAINS', value: term }],
        },
        {
          fieldName: 'statusProduct',
          conditions: [{ type: 'EQUALS', value: 'Publié' }],
        },
      ];

      if (this.listMemberCatalogSegmentation.length) {
        filters.push({
          fieldName: "nameSupplier",
          conditions: [
            {
              type: "IN",
              value: this.listMemberCatalogSegmentation as any
            }
          ]
        });
      };

      this.productService
        .getProductListByIdAndNameAndSupplierNumberAndBrand(
          {
            collectionName: 'dynamic_product',
            filters: filters,
            sorts: {},
            page: 1,
            pageSize: 5,
          },
          true
        )
        .subscribe((res: any) => {
          this.autocompleteSearchlistProducts = res.content;
          this.getFournisseurBySearchKeyword();
        });
    }
  }

  setSearchPipe() {
    this.searchProduct$
      .pipe(
        debounceTime(600),
        distinctUntilChanged()
      )
      .subscribe((searchProduct: string) => {
        if (searchProduct) {
          this.autocomplete(searchProduct);
        } else {
          this.autocompleteSearchlistProducts = [];
        }
      });
  }

  getListBrands(): void {
    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: [
          {
            fieldName: 'typeOfLegalEntity',
            conditions: [
              {
                type: 'EQUALS',
                value: 'MARQUE',
              },
            ],
          },
          {
            fieldName: 'Status',
            conditions: [
              {
                type: 'EQUALS',
                value: 'Publié',
              },
            ],
          },
        ],
        sorts: {
          publishedOrder: 'DESC',
        },
        page: 1,
        pageSize: 150,
      })
      .subscribe((res: any) => {
      });
  }

  selectItem(item: any): void {
    if (!item?.uniqueId) {
      this.formFilterProduct.patchValue({
        referenceProduct: item?.longDescription ?? "",
      })
      return;
    }
    this.router.navigate([`/catalogues/product-detail/${item?.uniqueId}`]);
  }

  toggleClpSafetyPictoStatus(value: boolean, event: any): void {
    // if (value === true && event.checked) {
    //   this.clpSafetyPicto2Control.setValue(false);
    // } else if (value === false && event.checked) {
    //   this.clpSafetyPicto1Control.setValue(false);
    // }
    if (event.checked?.length > 0) {
      this.formFilterProduct.patchValue({
        clpSafetyPicto: event.checked[0],
      });
    } else {
      this.formFilterProduct.patchValue({
        clpSafetyPicto: null,
      })
    };
  }

  toggleFoodContactStatus(value: boolean, event: any): void {
    // if (value === true && event.checked) {
    //   this.foodContact2Control.setValue(false);
    // } else if (value === false && event.checked) {
    //   this.foodContact1Control.setValue(false);
    // }
    if (event.checked?.length > 0) {
      this.formFilterProduct.patchValue({
        foodContact: event.checked[0],
      })
    } else {
      this.formFilterProduct.patchValue({
        foodContact: null,
      })
    }
  }

  toggleBiocideStatus(value: boolean, event: any): void {
    // if (value === true && event.checked) {
    //   this.biocide2Control.setValue(false);
    // } else if (value === false && event.checked) {
    //   this.biocide1Control.setValue(false);
    // }
    if (event.checked?.length > 0) {
      this.formFilterProduct.patchValue({
        biocide: event.checked[0],
      })
    } else {
      this.formFilterProduct.patchValue({
        biocide: null,
      })
    }
  }

  onChangeCategories(event: Dropdown) {
    this.getFournisseurBySearchKeyword();
  }

  getParamSearchFilters(value?: string) {
    let filters: Filter[] = [];
    const fieldNameArr = ['uniqueId', 'supplierItemNumber', 'brand', 'longDescription'];

    fieldNameArr.forEach((field) => {
      let conditions: any[] = [];
      let operator: string | undefined;

      operator = 'OR';
      conditions.push({
        type: field === 'uniqueId' ? 'EQUALS' : 'CONTAINS',
        value: value,
      });
      if (conditions.length) {
        filters.push({
          fieldName: field,
          operator: operator,
          conditions: conditions,
        });
      }
    });
    return filters;
  }

  extractValues(tree: any[]): any[] {
    if (!tree) return [];
    return tree?.flatMap((node: any) => {
      const currentNodeValue = node?.codeCategory
        ? [{ type: 'EQUALS', value: node?.codeCategory }]
        : [];

      const subValues = node?.subcategoryList
        ? this.extractValues(node?.subcategoryList)
        : [];
      return [...currentNodeValue, ...subValues];
    });
  }

  categoryOnlyFilter(code: string) {
    let dataTransfer;
    this._commonService.getAllCategoriesHandleSystem().subscribe((res) => {
      const tree = buildCategoryHierarchyRandom(res);
      const findNode = findCategoryByTree(code, tree);
      dataTransfer = this.extractValues([findNode]);
    });
    return dataTransfer;
  }

  getBodyFournisseurFilters() {

    let filters: any = [];

    const submitForm = {
      ...this.formFilterProduct.value,
      categoryProduct: this.formFilterProduct.value['categoryProduct']?.value,
      categoryProductLabel: this.formFilterProduct.value['categoryProduct']?.nameCategory,
    };

    if (submitForm.referenceProduct) {
      const referenceProduct = submitForm.referenceProduct;


      if (referenceProduct) {
        filters = [...filters, ...this.getParamSearchFilters(referenceProduct)];
      }
    }

    filters.push({
      fieldName: 'statusProduct',
      conditions: [
        {
          type: 'EQUALS',
          value: 'Publié',
        },
      ],
    });

    if (
      submitForm.categoryProduct
    ) {
      let condition;

      if (submitForm.categoryProduct) {
        const dataByCurrentIdCategory: any = this.categoryOnlyFilter(
          submitForm.categoryProduct
        );

        const exists = dataByCurrentIdCategory!.some(
          (item: any) => item?.value === submitForm.categoryProduct
        );
        if (exists) {
          condition = this.categoryOnlyFilter(submitForm.categoryProduct);
        }
      }

      filters.push({
        fieldName: 'categoryCode',
        conditions: condition,
      });
    } else if (submitForm.categoryProduct) {
      const condition = this.categoryOnlyFilter(submitForm.categoryProduct);
      filters.push({
        fieldName: 'categoryCode',
        conditions: condition,
      });
    }

    const body = [
      ...filters,
    ];

    return body
  }

  getFournisseurBySearchKeyword() {
    this.loadingSuplier = true;
    const filters = this.getBodyFournisseurFilters();
    const body: DynamicReferencedFilterParam = {
      page: 1,
      pageSize: 100000,
      fields: ['companyName', 'code'],
      referencedDocumentName: 'dynamic_product',
      referencedField: 'nameSupplier',
      referencedFilters: filters,
      sorts: {},
      referencedTimezone: 0,
      referencedLocales: ['fr-FR'],
    };
    this.dynamicDocumentService.getDynamicReferencedByFilter(body, 'dynamic_legal_entity').subscribe({
      next: (res: any) => {
        this.listSuppliers = res.content;

        const allSupplierObj: any = {};

        this.listSuppliers.forEach((sup) => {
          if (sup?.code) {
            allSupplierObj[sup.code] = sup?.companyName ?? sup.code;
          }
        });

        this.loadingSuplier = false;
      },
      error: () => {
        this.loadingSuplier = false;
      },
    });
  }

  public onDownload(event: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.newsDetail || !this.newsDetail.file || !this.newsDetail.file.file || !this.newsDetail.file.file[0]?.url) {
      return;
    }

    let fileName: string = this.newsDetail?.file?.file?.[0]?.url;
    fileName = fileName.substring(fileName.indexOf('/resource-files/') + '/resource-files/'.length);
    fileName = fileName.substring(0, fileName.indexOf('?'));

    if (this.hasUuid(fileName)) {
      fileName = fileName.substring(fileName.indexOf('_') + 1);
    }
    fileName = decodeURIComponent(fileName).toUpperCase().replace(/ /g, '-');
    fileName = fileName.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

    this._commonService.downloadFile(this.newsDetail?.file?.file?.[0]?.url, fileName);
  }

  private hasUuid(fileName: string): boolean {
    const uuid: string = fileName.substring(0, fileName.indexOf('_'));
    return (uuid.match(/-/g) || []).length === 4;
  }
}